module.exports = __webpack_public_path__ + "img/lamp-bg.d2d0c5ff.png";